import { Fragment, ReactElement } from 'react';
import PersonSipoNonResidentSearchShared from 'mutation/pages/registration-marriage/non-resident/edit-person-search';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface PersonSearchMarriageNonResidentNotificationsSharedProps {
  goBackUrl?: string;
  redirectUrl?: string;
  items?: BreadcrumbItem[];
}

const PersonSearchMarriageNonResidentNotificationsShared = ({
  goBackUrl = '',
  redirectUrl = '',
  items = [],
}: PersonSearchMarriageNonResidentNotificationsSharedProps): ReactElement => {
  return (
    <Fragment>
      <PersonSipoNonResidentSearchShared
        redirectUrl={redirectUrl}
        goBackUrl={goBackUrl}
        breadcrumbItems={items}
      />
    </Fragment>
  );
};

PersonSearchMarriageNonResidentNotificationsShared.displayName =
  'Research Marriage Non Resident Notifications Shared component';

export default PersonSearchMarriageNonResidentNotificationsShared;
